<script>
export default {
    props: {
        amount: {},
        currency: {
            type: String,
            default: ""
        },
        decimals: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        calculatedClasses() {
            if (this.amount == 0) {
                return "text-muted";
            }
        },
        currencyConfig() {
            if (this.decimals) {
                return {
                    style: "currency",
                    currency: this.currency,
                    currencyDisplay: "code"
                };
            } else {
                return {
                    style: "currency",
                    currency: this.currency,
                    currencyDisplay: "code",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0
                };
            }
        }
    }
};
</script>

<template>
    <span :class="calculatedClasses">
        <template v-if="amount != 0">
            {{ $n(amount, currencyConfig) }}
        </template>
        <template v-else>---</template>
    </span>
</template>
